module.exports = __webpack_public_path__ + "Tonno-uau.jpg";